import Environment from '@di-shared/features/environment/Environment';
import Eu from '@di-shared/features/history/tags/TagFormBottomSheet/.eu';
import Kr from '@di-shared/features/history/tags/TagFormBottomSheet/.kr';
import Na from '@di-shared/features/history/tags/TagFormBottomSheet/.na';

export interface TagFormBottomSheetData {
  initialTagName?: string;
}

export interface TagFormBottomSheetProps {
  initialTagName?: string;
}

export interface TagFormBottomSheetResult {
  tagName: string;
}

export default function TagFormBottomSheet({initialTagName}: TagFormBottomSheetProps) {
  return (
    <>
      <Environment.Eu>
        <Eu initialTagName={initialTagName} />
      </Environment.Eu>
      <Environment.Kr>
        <Kr initialTagName={initialTagName} />
      </Environment.Kr>
      <Environment.Na>
        <Na initialTagName={initialTagName} />
      </Environment.Na>
    </>
  );
}
